import { For, type JSX, Show } from 'solid-js';
import { t } from '../i18n';
import { LEGEND_RAMP, type LegendEntry } from '../lib/fleet-map';

// The Machines Map's legend (#6562, prototype `.legend`): one swatch per line, drawn with
// the squares' own `data-look` / `data-step`, its words and its count, then the hint. In a
// reading mode the ramp line shows four steps. Presenter over `mapLegend`.

export function MachineMapLegend(props: {
  readonly entries: readonly LegendEntry[];
  readonly hint: string;
}): JSX.Element {
  return (
    <div class="machine-map__legend">
      <ul class="machine-map__keys" aria-label={t('fleet.machines.map_legend_aria')}>
        <For each={props.entries}>
          {(e) => (
            <li class="machine-map__key">
              <Show
                when={e.look === 'ramp'}
                fallback={
                  <span class="machine-map__swatch" data-look={e.look} aria-hidden="true">
                    {e.glyph}
                  </span>
                }
              >
                <span class="machine-map__ramp" aria-hidden="true">
                  <For each={LEGEND_RAMP}>
                    {(step) => (
                      <span class="machine-map__swatch" data-look="ramp" data-step={step} />
                    )}
                  </For>
                </span>
              </Show>
              <span>{e.label}</span>
              <span class="machine-map__count">{e.count}</span>
            </li>
          )}
        </For>
      </ul>
      <p class="machine-map__hint">{props.hint}</p>
    </div>
  );
}
